<template>
  <Container background-color="#F5F7FA" :bounds-inner-styles="containerStyles">
    <h2 class="scout-startups-title">
      Growing the Nordic startup scene since 2015, one hire at a time
    </h2>
    <b-row class="scout-startups-description_wrapper">
      <div class="scout-startups-description_wrapper-pattern">
        <img src="@/assets/pages/scout/small_grey_pattern.svg" />
      </div>
      <div class="scout-startups-description_wrapper-text">
        <!-- For almost a decade, we’ve helped 14,000 Nordic startups hire startup-minded talents,
        spanning a variety of industries, skill levels, and backgrounds. We exist to connect
        exceptional people with exceptional companies, and with
        <a href="/scout" target="_blank"><b>Scout</b></a> we are able to do so with unparalleled
        efficiency. No matter what you’re looking for in your next hire, you’ll find it here. -->
        For almost a decade, we’ve helped 14,000 Nordic startups hire startup-minded talents,
        spanning a variety of industries, skill levels, and backgrounds. Curious to learn more?
        <a
          style="cursor:pointer; color:#4440DB"
          target="_blank"
          href="https://calendar.app.google/Si9262EWkGAUWzJN9"
          >Book a call</a
        >.
      </div>
    </b-row>
    <b-row class="scout-startups-startups">
      <div
        v-for="startup in startups"
        :key="startup.key"
        class="scout-startups-startup_wrapper"
        @click="onStartupClick(startup)"
      >
        <a
          class="scout-startups-startup_link"
          :href="`/startups/${startup.key}`"
          target="blank"
        ></a>
        <img class="scout-startups-startup_logo" :src="startup.img" />
      </div>
    </b-row>
  </Container>
</template>

<script>
import Container from '@/components/Container';

export default {
  name: 'ScoutStartups',
  components: {
    Container
  },
  props: {},
  data() {
    return {
      startups: [
        {
          key: 'contractbook-or-better-contracts',
          img: require('@/assets/pages/scout/contractbook_logo.svg')
        },
        { key: 'glint-solar', img: require('@/assets/pages/scout/glint_solar_logo.svg') },
        { key: 'legacy', img: require('@/assets/pages/scout/legacy_logo.svg') },
        { key: 'kanpla', img: require('@/assets/pages/scout/kanpla_logo.svg') },
        { key: 'reshape-biotech', img: require('@/assets/pages/scout/reshape_logo.svg') },

        { key: 'superb', img: require('@/assets/pages/scout/superb_logo.svg') },
        { key: 'doublepoint', img: require('@/assets/pages/scout/doublepoint_logo.svg') }
      ]
    };
  },
  methods: {
    onStartupClick(startup) {
      // window && window.open(`/startups/${startup.id}`, '_blank');
    }
  },
  computed: {
    containerStyles() {
      return {
        'padding-top': `${2}rem`,
        'padding-bottom': `${4.5}rem`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.scout {
  a {
    color: #4440db;
  }
  &:hover {
    text-decoration: underline !important;
  }
}

.scout-startups-title {
  margin-top: 1.5rem;
  width: 70%;
  @include media-breakpoint-down(md) {
    width: 100%;
  }
}

.scout-startups-description_wrapper {
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  // width: 100%;
  margin-top: 1rem;

  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 8px;
  grid-row-gap: 0px;

  @include media-breakpoint-down(md) {
    grid-template-columns: repeat(1, 1fr);
  }
}

.scout-startups-description_wrapper-pattern {
  // width: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
  grid-area: 1 / 2 / 2 / 3;
  @include media-breakpoint-down(md) {
    display: none;
  }
}

.scout-startups-description_wrapper-text {
  // width: 65%;
  font-size: rem(18px);
  text-align: justify;
  grid-area: 1 / 4 / 2 / 11;
  margin-right: 15px;
  @include media-breakpoint-down(sm) {
    // margin-right: 15px;
  }
}

.scout-startups-startups {
  transform: scaleX(-1);
  // margin-top: 4rem;
  display: grid;
  margin: 4rem 0px 0px 0px;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0.5rem;
  grid-row-gap: 0.5rem;
  @include media-breakpoint-down(md) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
  }
  @include media-breakpoint-down(xs) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
  }
}

.scout-startups-startup_wrapper {
  cursor: pointer;
  transform: scaleX(-1);
  background-color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  // height: rem(100px);
  &:hover {
    box-shadow: 0 30px 90px 0 rgba(31, 36, 48, 0.1);
  }
  transition: all 0.2s ease-in-out;

  transition-delay: 0s;
}

.scout-startups-startup_link {
  width: 100%;
  height: 100%;
  position: fixed;
}

.scout-startups-startup_logo {
  width: inherit;
}
</style>
